import React from 'react';

import { IconRcCopy } from 'assets/login';
import message from 'antd/es/message';

export const copyFn = (value: string) => {
  const textArea = document.createElement('textarea');
  textArea.value = value;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand('copy');
    const msg = successful ? 'successful' : 'unsuccessful';
    console.debug('Fallback: Copying text command was ' + msg);
    message.success('Copied', 1);
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
};
export default ({
  value,
  size = 20,
  className,
}: {
  value: string;
  size?: number;
  className?: string;
}) => {
  const sizeStyle = {
    width: `${size}`,
    height: `${size}`,
  };
  return (
    <IconRcCopy
      className={className}
      style={{ cursor: 'pointer', color: 'var(--bg-default-color)', ...sizeStyle }}
      onClick={() => {
        copyFn(value);
      }}
    />
  );
};
